import { ContentBody } from "../../components/data/data/HelpCenter/GetStarted";
import ArticleLayout from "../../components/HelpCenterComponents/ArticleLayout";

const ARTICLE_TITLES = [
  'Introduction to Spatial Grid',
  'Understanding Spatial Grid Use Cases',
  'Platform Architecture and Capabilities',
  'Device & Hardware Support',
  'Creating & Managing Experiences',
  'User Roles, Access and Governance',
  'Analytics, Insights and Reporting',
  'Deployment, Integration and IT Readiness',
  'Enterprise Enablement and Support',
];

const TOC_DATA = {
  0: [
    'What is Spatial Grid',
    'Platform Philosophy',
    'Core Capabilities',
    'Enterprise Value',
  ],
  1: [
    'Understanding Spatial Grid Use Cases',
    'Immersive Training & SOP Enablement',
    'Simulation & Operational Readiness',
    'Digital Twins & Spatial Visualization',
    'Interactive Marketing & Engagement',
    'Education & Research',
  ],
  2: [
    'Modular Architecture',
    'Spatial Engines & Interaction Systems',
    'AI Plug-ins & Intelligence Layer',
    'Analytics & Data Layer',
    'Scalability & Performance',
  ],
  3: [
    'Supported Device Types',
    'Device Abstraction Layer',
    'Develop Once, Deploy Anywhere',
    'Hardware Flexibility & Future Readiness',
  ],
  4: [
    'Experience Design Workflow',
    'Content Structuring & Scene Logic',
    'Collaboration Across Teams',
    'Updates & Lifecycle Management',
  ],
  5: [
    'Enterprise User Management',
    'Roles & Permissions',
    'Access Control & Security',
    'Governance Models',
  ],
  6: [
    'Interaction & Engagement Metrics',
    'Performance & Effectiveness Measurement',
    'Reporting for Stakeholders',
    'Data-Driven Optimization',
  ],
  7: [
    'Deployment Models',
    'Integration with Enterprise Systems',
    'IT & Security Alignment',
    'Operational Readiness',
  ],
  8: [
    'Onboarding & Training',
    'Consulting & Co-Creation',
    'Support & Maintenance',
    'Scaling with Confidence',
  ],
};


const GettingStartedArticles = () => {
  return (
    <ArticleLayout
      articleTitles={ARTICLE_TITLES}
      tocData={TOC_DATA}
      ContentBodyComponent={ContentBody}
      sectionName="GettingStarted"
      searchPlaceholder="Search the Spatial Grid Help Center"
      showUseCases={true}
      // showTitle={true}
    />
  );
};

export default GettingStartedArticles;